import Layout from "./Layout";
import UpdateUser from "../components/UpdateUser.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

const UserUpdates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <UpdateUser />
        </Layout>
      )}
      {/* Add a loader or handle unauthorized access */}
    </>
  );
};

export default UserUpdates;
